import React from 'react';

// custom display for current image out of total images

const CurrentImageCount = ({images, currentImage}) => {
  const current = images.findIndex(image => image.id === currentImage.id) + 1 ;
  const total = images.length;

  return `${current}/${total}`;
};

export default CurrentImageCount;



// WEBPACK FOOTER //
// ./public/components/images/CurrentImageCount.jsx